import React from "react";
import clsx from "clsx";
import { isEmpty } from "lodash";
import { connect } from "react-redux";

import styles from "./loader.module.scss";

const SpinnerOverlay = ({
	visible,
	additionalTitle,
	isTransparent,
	isLazySpinner = false,
}) => {
	const notTransparentClass = isTransparent || styles.notTransparent;
	const lazySpinnerOverlayClass = isLazySpinner && styles.lazySpinnerOverlay;

	const spinner = (
		<div
			className={clsx(
				styles.spinnerOverlay,
				notTransparentClass,
				lazySpinnerOverlayClass,
			)}
		>
			<div className={styles.spinner}></div>
			{!isEmpty(additionalTitle) && (
				<div className={styles.spinnerAdditionalContainerTitle}>
					<p className="mb-0 font-italic">Please wait.</p>
					<p className="font-italic">{additionalTitle}</p>
				</div>
			)}
		</div>
	);

	return visible ? spinner : null;
};

const mapStateToProps = state => ({
	visible: state.ui.isSpinnerOverlayVisible,
	isTransparent: state.ui.isOverlayTransparent,
	additionalTitle: state.ui.spinnerOverlayAdditionalTitle,
});

export default connect(mapStateToProps)(SpinnerOverlay);
